import { Skeleton, Flex } from 'antd';
import { FC } from 'react';

interface MenuSkeletonProps {
  children: React.ReactNode;
  isLoading: boolean;
  isCollapsed?: boolean;
}

const MenuSkeleton: FC<MenuSkeletonProps> = ({ children, isLoading, isCollapsed }) => {
  if (!isLoading) {
    return children;
  }

  return (
    <Flex vertical gap={8} flex={1} justify="center">
      <Flex gap={8} justify="center">
        <Skeleton.Avatar active size="small" shape="square" />
        {!isCollapsed && <Skeleton.Input active size="small" />}
      </Flex>
      <Flex gap={8} justify="center">
        <Skeleton.Avatar active size="small" shape="square" />
        {!isCollapsed && <Skeleton.Input active size="small" />}
      </Flex>
      <Flex gap={8} justify="center">
        <Skeleton.Avatar active size="small" shape="square" />
        {!isCollapsed && <Skeleton.Input active size="small" />}
      </Flex>
    </Flex>
  );
};

export default MenuSkeleton;
